import type { HelpFile } from '../../types/help'
import { AnnouncerTestIds } from '../../../testids/AnnouncerTestIds'

export const announcerHelp: HelpFile = {
  texts: {
    // Polite aria-live region driven by the app's Announcer. Invisible to
    // sighted users — opt out of help via null.
    [AnnouncerTestIds.announcerLiveRegion]: null,
  },
}
